<!-- 使用到的租户 还呗、wxjk、嘉银、58、微财 -->
<template>
  <div
    v-if="benefitList.length > 0"
    class="benefit-wrap"
    :class="{ 'benefit-image': item.display_code === 'benefitImage' }"
  >
    <div class="title">
      {{ item.name }}
    </div>
    <div
      v-for="product in benefitList"
      :key="product.id"
      class="content"
      :style="{ background: `url(${product.display_img_url})` }"
      :data-type="product.benefit_type"
    >
      <div
        class="content-btn"
        @click="handleShowDetail(product)"
        v-if="showBtn"
      >
        查看详情
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, watch, computed, ref } from "@vue/composition-api";
import { useRouter, useStore, useRoute } from "@/components/use/base";

export default defineComponent({
  props: ["item", "card", "allBenefitList"],

  setup(props) {
    const router = useRouter();
    const store = useStore();
    const route = useRoute();

    const benefitList = ref([]);
    const isMember = computed(() => store.state.isMember);
    const namespaceGroup = computed(
      () => store.state.namespaceInfo.namespace_group_en
    );
    const showBtn = computed(() => {
      if (route.name === "visitor") {
        return !["58sk", "weicai"].includes(namespaceGroup.value);
      }
      return true;
    });

    // 会员时，取用户有的权益
    watch(
      isMember,
      (newVal) => {
        if (newVal && route.name !== "visitor") {
          const list = props.item.productInfo;
          const userBenefitList =
            props.card?.benefit_list?.map((item) => item.type) || [];
          benefitList.value = list.filter((item) =>
            userBenefitList.includes(item.benefit_type)
          );
        }
      },
      { immediate: true, deep: true }
    );

    // 有token但非会员/无token/未开通页情况，取租户权益
    watch(
      () => props.allBenefitList,
      (newVal) => {
        if (route.name === "visitor" || !isMember.value) {
          benefitList.value = props.item.productInfo.filter((item) =>
            newVal.includes(item.benefit_type)
          );
        }
      },
      { immediate: true, deep: true }
    );

    const handleShowDetail = (item) => {
      router.push(`benefitDetail?benefit_type=${item.benefit_type}`);
    };

    return { handleShowDetail, benefitList, showBtn };
  },
});
</script>

<style scoped lang="less">
.benefit-wrap {
  padding: 0 12px;
  margin-top: 32px;

  &.benefit-image {
    margin-top: 0;
  }

  .title {
    font-weight: 600;
    font-size: 18px;
    color: #222222;
    line-height: 22px;
  }

  .desc {
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    line-height: 16px;
    margin-top: 7px;
  }

  .content {
    position: relative;
    margin-top: 16px;
    width: 351px;
    height: 122px;
    border-radius: 8px;
    box-sizing: border-box;
    background-repeat: no-repeat !important;
    background-size: 100% !important;

    .content-btn {
      width: 70px;
      height: 24px;
      background: linear-gradient(115deg, #dfbd94 0%, #ffe8c8 100%);
      border-radius: 13px;
      position: absolute;
      top: 50%;
      right: 23px;
      transform: translateY(-50%);

      font-weight: 500;
      font-size: 12px;
      color: #000000;
      line-height: 24px;
      text-align: center;
    }
  }
}
</style>
